import axios from 'axios';

const ContactApi = {
    postContactForm : (data) => {
        return axios.post('/api/contact/submitform', data, { headers: { 'Content-Type': 'application/json' } });
    }
}

export default ContactApi;